/**
 * LERA Viewport Layer — Sprint S8.11A
 * Singleton portal host for floating LERA components.
 * Create once, reuse forever. Never duplicate.
 */
(function () {
  const LAYER_ID = 'LeraViewportLayer';

  function ensure() {
    let layer = document.getElementById(LAYER_ID);
    if (layer) return layer;

    layer = document.createElement('div');
    layer.id = LAYER_ID;
    layer.setAttribute('data-lera-viewport-layer', '');
    layer.setAttribute('data-lera-viewport-version', '8.11A');

    const parent = document.body || document.documentElement;
    parent.appendChild(layer);
    return layer;
  }

  function get() {
    return document.getElementById(LAYER_ID);
  }

  /**
   * Move an existing node into the viewport layer (portal).
   * Never clones. Idempotent for the same node.
   */
  function portal(node, { slot } = {}) {
    if (!node || !(node instanceof Element)) return null;
    const layer = ensure();
    if (slot) node.setAttribute('data-lera-viewport-slot', slot);
    if (node.parentElement !== layer) {
      layer.appendChild(node);
    }
    node.setAttribute('data-lera-portaled', '1');
    return node;
  }

  window.LeraViewportLayer = {
    id: LAYER_ID,
    version: '8.11A',
    ensure,
    get,
    portal,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensure, { once: true });
  } else {
    ensure();
  }
})();
